
/*
    Display for a location message, which can be clicked to open the edit form
*/

import React from "react";

import DataItem from "../Components/DataItem";

import MessagesLocationForm from "../Forms/MessagesLocationForm";

const MessageLocationData =  (props) => {

    /*
        fullscreen: "false"
        locationID: "ATLC"
        message: "this is a test"
    */

    return (
        <>
        {
            props.expanded
            ? <div className="data">
                <MessagesLocationForm data={props.data} reload={props.reload} close={() => props.runOpen(null)} />
            </div>
            : <div className="data shadow-card" style={{
                display: "grid",
                gridTemplateColumns: "1fr 6fr 2fr 1fr",
                gridGap: "8px",
                padding: "8px"
            }}>
                <div><DataItem val={props.data.displayName}/></div>
                <div>{props.data.message}</div>
                <div>fullscreen: <DataItem val={props.data.fullscreen}/></div>
                <div className="option  " onClick={() => props.runOpen(props.containerIndex)}>EDIT</div>
            </div>
        }
        </>
    )
};

export default MessageLocationData;